import * as Api from '@ViewModels';

export { getResourceSelectorIdDisplayName } from './automationDisplayConfig';

/**
 * Gets key date kind from resource selector ID
 * @source Original location: UiUtils.ts.backup line 1663
 */
export const getKeyDateKindFromResourceSelectorId = (resourceSelectorId: Api.ResourceSelectorId): Api.KeyDateKind => {
	switch (resourceSelectorId) {
		case Api.ResourceSelectorId.HouseAnniversaries:
			return Api.KeyDateKind.Anniversary;
		case Api.ResourceSelectorId.HappyBirthday:
			return Api.KeyDateKind.Birthday;
		case Api.ResourceSelectorId.FinancialReview:
			return Api.KeyDateKind.FinancialReview;
		case Api.ResourceSelectorId.PolicyRenew:
			return Api.KeyDateKind.Renewal;
		case Api.ResourceSelectorId.Undefined:
			return Api.KeyDateKind.Unknown;
		case Api.ResourceSelectorId.Turning65:
			return Api.KeyDateKind.Turning65;
		case Api.ResourceSelectorId.Turning72:
			return Api.KeyDateKind.Turning72;
		case Api.ResourceSelectorId.Turning73:
			return Api.KeyDateKind.Turning73;
		case Api.ResourceSelectorId.TurningXX:
			return Api.KeyDateKind.TurningXX;
		case Api.ResourceSelectorId.TurningXX2:
			return Api.KeyDateKind.TurningXX2;
		case Api.ResourceSelectorId.TurningXX3:
			return Api.KeyDateKind.TurningXX3;
		case Api.ResourceSelectorId.TurningXX4:
			return Api.KeyDateKind.TurningXX4;
		case Api.ResourceSelectorId.TurningXX5:
			return Api.KeyDateKind.TurningXX5;
		case Api.ResourceSelectorId.Custom1:
			return Api.KeyDateKind.Custom1;
		case Api.ResourceSelectorId.Custom2:
			return Api.KeyDateKind.Custom2;
		case Api.ResourceSelectorId.Custom3:
			return Api.KeyDateKind.Custom3;
		case Api.ResourceSelectorId.Custom4:
			return Api.KeyDateKind.Custom4;
		case Api.ResourceSelectorId.Custom5:
			return Api.KeyDateKind.Custom5;
		case Api.ResourceSelectorId.Custom6:
			return Api.KeyDateKind.Custom6;
		case Api.ResourceSelectorId.Custom7:
			return Api.KeyDateKind.Custom7;
		case Api.ResourceSelectorId.Custom8:
			return Api.KeyDateKind.Custom8;
		case Api.ResourceSelectorId.Custom9:
			return Api.KeyDateKind.Custom9;
		case Api.ResourceSelectorId.Custom10:
			return Api.KeyDateKind.Custom10;
		default:
			return null;
	}
};

/**
 * Gets subvertical options for industry
 * @source Original location: UiUtils.ts.backup line 1800
 */
export const getSubverticalOptions = (industry: Api.Industry) => {
	switch (industry) {
		case Api.Industry.Insurance:
			return [
				'Personal P&C',
				'Commercial P&C',
				'Personal Health & Benefits',
				'Group Health & Benefits',
				'MGA / Wholesale',
				'Construction',
				'Wealth & Retirement Planning',
				'Life Insurance',
				'Medicare',
				'Crop Insurance',
				'Other',
			];
		case Api.Industry.Legal:
			return [
				'Bankruptcy',
				'Business Law',
				'Criminal Defense',
				'Estate / Elder / Probate Law',
				'Family Law',
				'General Practice',
				'Litigation',
				'Personal Injury',
				'Real Estate',
				'Immigration',
				'Workers Compensation',
				'Intellectual Property',
				'Mediation',
				'Employment Law',
				'Other',
			];
		case Api.Industry.Financial:
			return [
				'Wealth & Retirement Planning',
				'401K',
				'Banking',
				'CPA',
				'Employee Benefits',
				'Life Insurance',
				'Mortgage Lender',
				'Registered Investment Advisor',
				'Venture Capital',
				'High-Net-Worth Clients',
				'Other',
			];
		case Api.Industry.RealEstate:
		case Api.Industry.Mortgage:
			return [
				'Residential',
				'Commercial',
				'Mortgage Lender',
				'Property Management',
				'Vacation Properties & Rentals',
				'Recruiting',
				'Other',
			];
		case Api.Industry.Miscellaneous:
		case Api.Industry.Others:
			return [
				'B2B',
				'B2C',
				'Recruiting',
				'Consulting',
				'Nonprofit',
				'Education',
				'Manufacturing',
				'Software/Tech',
				'Other',
			];
		case Api.Industry.Accounting:
			return [
				'Public',
				'Government',
				'Forensic',
				'Bookkeeping & Payroll',
				'Auditor',
				'Business Tax Preparation',
				'Individual Tax Preparation',
				'Other',
			];
		case Api.Industry.NonProfit:
			return [
				'Senior Care & Services',
				'Child & Adult Disability Services',
				'Education, Employment, & Literacy',
				'Religious Organization',
				'Member Association',
				'Boys & Girls Clubs',
				'Healthcare Svcs and/or Awareness',
				'Environmental Preservation',
				'Community Development',
				'Food Security & Nutrition',
				'Human Rights & Social Justice',
				'Housing & Poverty',
				'Youth Services',
				'Domestic Violence & Abuse',
				'Substance Abuse Support',
				'Outdoor Ed./Sports & Rec.',
				'Arts & Cultural Exposure',
				'Military Services & Support',
				'Animal Welfare',
				'Other',
			];
		case Api.Industry.HomeMaintenance:
			return [
				'HVAC',
				'Plumbing',
				'Electrical',
				'Refrigeration',
				"Manufacturers' Rep",
				'Distributor',
				'Retail',
				'Remodeler',
				'Roofing',
				'Lennox Co-Branded Content',
				'Other',
			];
		case Api.Industry.Health:
			return ['Chiropractic', 'Dental', 'Wellness', 'Acupuncture', 'Other'];
		default:
			return [];
	}
};

/**
 * Checks if industry supports subverticals
 * @source Original location: UiUtils.ts.backup line 1923
 */
export const industrySupportsSubverticals = (industry: Api.Industry) => {
	return getSubverticalOptions(industry).length > 0;
};
